<template>
  <div class="contents group-member">
    <h2>あなたの管理するグループ</h2>
    <template v-if="isLoading">
      <loading :isLoading="isLoading" :message="'読み込み中...'"></loading>
    </template>

    <section class="group" v-for="(group, index) in groupWithMemberList"
      v-if="groupWithMemberList.length > 0 && !isLoading">
      <h3>グループ名：{{ group.group_name }}</h3>
      <p>{{ groupDescription(group.syounin_type) }}</p>
      <scroll-table>
        <table v-if="!isLoading" class="list-table">
          <thead>
            <tr>
              <th>社員番号</th>
              <th>氏名</th>
              <th>操作</th>
            </tr>
          </thead>
          <tbody>
            <template v-for="member in group.group_users" v-if="group.group_users.length > 0">
              <tr>
                <td>{{ member.staff_code }}</td>
                <td>{{ member.staff_name }}</td>
                <td>
                  <p @click="control(group.syounin_type)">{{ controlText(group.syounin_type) }}</p>
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </scroll-table>
    </section>

    <template v-else>
      <p>表示できる承認グループはありません</p>
    </template>
  </div>
</template>

<script lang="ts">
import { useTeamMemberInit } from '@/composable/syain/group_member/init';
import OptionConst from '@/const/Option';
import { BelongsGroup, ManagedGroup } from '@/types/SyouninGroup';
import { defineComponent, onMounted, ref, Ref } from 'vue';

export default defineComponent({
  setup() {
    let belongsGroup: Ref<BelongsGroup[]> = ref([]);
    let mangedGroup: Ref<ManagedGroup[]> = ref([]);
    const { isLoading, groupWithMemberList, getGroupMember } = useTeamMemberInit()

    onMounted(async () => {
      await getGroupMember()
    })

    const groupDescription = ((type: number) => {
      switch (type) {
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN:
          return '日々の勤怠状況チェックの対象者グループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYUUSEI:
          return '打刻記録修正の対象者グループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.JIKANGAI:
          return 'あなた宛に時間外申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.FURIKYUU:
          return 'あなた宛に振休・振出申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.CHIKOKU:
          return 'あなた宛に遅刻申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.SOUTAI:
          return 'あなた宛に早退申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.KEKKIN:
          return 'あなた宛に欠勤申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.YUUKYUU:
          return 'あなた宛に有給申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.KIBIKI:
          return 'あなた宛に忌引き届申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.IDOU:
          return 'あなた宛に異動届申請を提出するグループです。'
        // case OptionConst.SYOUNIN_FLOW_TYPES.KIKEN:
        //   return 'あなた宛に危険手当申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.NITTYOKU:
          return 'あなた宛に日直申請を提出するグループです。'
        // case OptionConst.SYOUNIN_FLOW_TYPES.KOSYOKU:
        //   return 'あなた宛に個食手当申請を提出するグループです。'
        // case OptionConst.SYOUNIN_FLOW_TYPES.SONOTA:
        //   return 'あなた宛にその他手当申請を提出するグループです。'
        case OptionConst.SYOUNIN_FLOW_TYPES.KOYOUKEIYAKU:
          return '雇用契約書の確認対象者のグループです。'
        default:
          return 'このグループの説明はありません。'
      }
    })

    const controlText = ((type: number) => {
      switch (type) {
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN:
          return '勤怠チェック'
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYUUSEI:
          return '打刻修正の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.JIKANGAI:
          return '時間外申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.FURIKYUU:
          return '振休・振出申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.CHIKOKU:
          return '遅刻申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.SOUTAI:
          return '早退申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.KEKKIN:
          return '欠勤申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.YUUKYUU:
          return '有給申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.KIBIKI:
          return '忌引き届申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.IDOU:
          return '異動届申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.KIKEN:
          return '危険手当申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.NITTYOKU:
          return '日直手当申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.KOSYOKU:
          return '個食手当申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.SONOTA:
          return 'その他手当申請の確認'
        case OptionConst.SYOUNIN_FLOW_TYPES.KOYOUKEIYAKU:
          return '雇用契約書の確認'
        default:
          return '可能な操作はありません'
      }
    })

    const control = ((type: number) => {
      switch (type) {
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYOUNIN:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.DAKOKU_SYUUSEI:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.JIKANGAI:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.FURIKYUU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.CHIKOKU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.SOUTAI:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.KEKKIN:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.YUUKYUU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.KIBIKI:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.IDOU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.KIKEN:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.NITTYOKU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.KOSYOKU:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.SONOTA:
          break
        case OptionConst.SYOUNIN_FLOW_TYPES.KOYOUKEIYAKU:
          break
        default:
          return
      }
    })

    return {
      belongsGroup,
      mangedGroup,
      isLoading,
      groupWithMemberList,
      controlText,
      control,
      groupDescription
    }
  }
})
</script>

<style scoped>

</style>